module.exports = __webpack_public_path__ + "img/not-found.603caff8.png";